
import { defineComponent, reactive, onBeforeMount, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'

import ConnectionState from '@/common/components/ConnectionState/index.vue'
import ClientCard from '@/modules/OktellModule/components/ClientCard/index.vue'
import CallReportForm from '@/modules/OktellModule/components/CallReportForm/index.vue'
import OkWhatsapp from '@/modules/OktellModule/components/OkWhatsapp/index.vue'
import OkDealForm from '@/modules/OktellModule/components/OkDealForm/index.vue'

import { http } from '@/core/realisations/Http.realisation'

import { useOktellStore } from '@/modules/OktellModule/store/useOktellStore'
import { useConnectionStore } from '@/store/connectionStore'

export default defineComponent({
    components: {
        ConnectionState,
        ClientCard,
        CallReportForm,
        OkWhatsapp,
        OkDealForm,
    },
    setup() {
        const connectionStore = useConnectionStore()
        const route = useRoute()

        const state = reactive({
            isDealModalOpened: false,
        })

        const token = route.query.token as string | undefined
        const phone = route.query.phone as string | null
        const operatorEmail = route.query.email as string | null

        const oktellStore = useOktellStore()

        const initializeToken = () => {
            if (!token) return
            http.setAuthorization(token, 'Bearer')
        }

        onBeforeMount(() => {
            initializeToken()

            if (phone) {
                oktellStore.checkWhatsapp(phone)
                oktellStore.loadClient(phone)
            }
        })

        onBeforeUnmount(oktellStore.resetStore)

        const onDeal = () => {
            state.isDealModalOpened = true
        }

        const onCancelDeal = () => {
            state.isDealModalOpened = false
        }

        return {
            state,
            connectionStore,
            oktellStore,
            phone,
            operatorEmail,
            onDeal,
            onCancelDeal,
        }
    },
})
